module.exports = __webpack_public_path__ + "static/media/nagly-wypadek-zdrowotny.e04dbeb8.svg";